import React from 'react';

export default class GifLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        }
    }

    componentDidMount() {
        let img = new Image();
        img.onload = () => {
            this.setState({loading: false});
        };
        img.src = this.props.src;
    }

    render() {
        if(this.state.loading) return <span>Loading...</span>;
        return <img src={this.props.src} class="video-img" alt={this.props.alt} />
    }
}